import FetchCode from './FetchCode';

export default FetchCode;
